import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.NgramsView extends Monitoring.Reports.Executive.AbstractSectionView
  template: JST["backbone/templates/monitoring/reports/executive/ngrams"]
  tagName: 'section'
  id: 'ngrams'

  render: ->
    @$el.html(@template(
      brandLabel:@options.settings.accountLabel
      competitorsLabels: @options.settings.competitorsLabels
    ))
    @labels = [@options.settings.accountLabel].concat @options.settings.competitorsLabels
    @bindChartsReady(@labels.length)
    for label in @labels
      @startJob(label)
    return this

  startJob: (label) ->
    job = new Monitoring.Methods.AsyncJob()
    divSelector = '#' + label.codes[0] + ' .cloud'
    job.bind('completed', (response) => @addWordsCloud(response, divSelector))
    query = {
      ngrams_limit: 20
      date_from_ISO: @options.fromISO.toISOString()
      date_to_ISO: @options.toISO.toISOString()
      labels: label.codes
    }
    job.start('words', query)
